import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { basename } from "./lib/vertical";
import { App } from "./App";

import "./styles/kaira-flights.css";
import "./styles/pages.css";
import "./styles/hotels.css";

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      // Search/booking data is short-lived (a flight trace expires in ~15 min,
      // a hotel search session in 10). Match that with a 30s stale window —
      // anything we cache longer is just bandwidth, not correctness.
      staleTime: 30_000,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* One build, two verticals: the basename is read off the URL prefix so
        /flights/* and /hotels/* mount the same app with different route trees.
        See lib/vertical.ts. */}
    <BrowserRouter basename={basename()}>
      <QueryClientProvider client={qc}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
